import React from 'react';
import InfoBox from 'components/widget/InfoBox';

export default () => (
  <InfoBox>
    We&apos;re sorry, you are not able to skip your first scheduled delivery.
  </InfoBox>
);
